// extracted by mini-css-extract-plugin
module.exports = {"Label":"RuleCommand_Label__24j6S"};